var moduleMap = {
	"./Pages": () => {
		return Promise.all([__webpack_require__.e(4673), __webpack_require__.e(561), __webpack_require__.e(3166), __webpack_require__.e(303), __webpack_require__.e(6873), __webpack_require__.e(4473), __webpack_require__.e(3236), __webpack_require__.e(6832), __webpack_require__.e(9573), __webpack_require__.e(8692), __webpack_require__.e(5989), __webpack_require__.e(735), __webpack_require__.e(2064), __webpack_require__.e(1449), __webpack_require__.e(3867), __webpack_require__.e(5924), __webpack_require__.e(3239), __webpack_require__.e(1420), __webpack_require__.e(3842), __webpack_require__.e(7850), __webpack_require__.e(9027), __webpack_require__.e(484), __webpack_require__.e(9937), __webpack_require__.e(1342), __webpack_require__.e(4418), __webpack_require__.e(4932), __webpack_require__.e(8495), __webpack_require__.e(6587)]).then(() => (() => ((__webpack_require__(8132)))));
	},
	"./Reducers": () => {
		return Promise.all([__webpack_require__.e(3842), __webpack_require__.e(9027), __webpack_require__.e(7971), __webpack_require__.e(8495), __webpack_require__.e(7329)]).then(() => (() => ((__webpack_require__(37329)))));
	},
	"./Actions": () => {
		return __webpack_require__.e(2779).then(() => (() => ((__webpack_require__(12779)))));
	},
	"./Translations": () => {
		return __webpack_require__.e(2626).then(() => (() => ((__webpack_require__(82626)))));
	},
	"./Types": () => {
		return __webpack_require__.e(3263).then(() => (() => ((__webpack_require__(3263)))));
	},
	"./Sagas": () => {
		return Promise.all([__webpack_require__.e(6873), __webpack_require__.e(3239), __webpack_require__.e(3842), __webpack_require__.e(7850), __webpack_require__.e(9027), __webpack_require__.e(2864)]).then(() => (() => ((__webpack_require__(35161)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});